import { DefaultService } from '@/services/DefaultService';

export default class ProProdutoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(produto) {
        return this._http.post(`${this._env}/promotor/produto`, produto, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/produto/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/produto/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(page = 0, limit = 50, sort, ...param) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/promotor/produto.json?page=${page}&limit=${limit}&column=${
                        sort.column
                    }&order=${sort.order}&param=${param}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(produto) {
        return this._http
            .post(`${this._env}/promotor/produto/updateSituacao`, produto, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
